import styled from 'styled-components';

// Mirrors PlanAction's container — same gray fill, border, radius, padding,
// and "PLAN" eyebrow header style. The badge+label row sits beneath the
// eyebrow, matching how a Step row sits inside the plan card.
export const Base = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
	margin: 8px 0;
	padding: 14px 16px;
	padding-top: 10px;
	background-color: ${({ theme }) => theme.gray[100]};
	border: 1px solid ${({ theme }) => theme.gray[200]};
	border-radius: 10px;
`;

export const Eyebrow = styled.div`
	font-size: 12px;
	font-weight: 600;
	letter-spacing: 0.04em;
	text-transform: uppercase;
	color: ${({ theme }) => theme.gray[700]};
`;

export const Row = styled.div`
	display: flex;
	align-items: flex-start;
	gap: 10px;
	font-size: 13px;
	line-height: 1.4;
	color: ${({ theme }) => theme.gray[900]};
`;

export const Badge = styled.span`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
	width: 20px;
	height: 20px;
	border-radius: 50%;
	background-color: ${({ theme }) => theme.gray[200]};
	color: ${({ theme }) => theme.gray[800]};
	font-size: 11px;
	font-weight: 600;
`;

export const Label = styled.span`
	padding-top: 2px;
`;
